import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import DashboardPanel, { DashboardSpec } from "@/components/DashboardPanel";
import { Loader2 } from "lucide-react";
import { toTitleCase } from "@/lib/text-utils";

const SharedDashboard = () => {
  const { id } = useParams<{ id: string }>();
  const [dashboard, setDashboard] = useState<DashboardSpec | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetch = async () => {
      if (!id) return;
      const { data, error } = await supabase
        .from("shared_dashboards")
        .select("title, spec")
        .eq("id", id)
        .single();

      if (error || !data) {
        setError("Dashboard not found or has been removed.");
      } else {
        setDashboard({ title: toTitleCase(data.title), widgets: (data.spec as any).widgets || [] });
      }
      setLoading(false);
    };
    fetch();
  }, [id]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <p className="text-muted-foreground">{error}</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <DashboardPanel dashboard={dashboard} loading={false} onClose={() => window.close()} isPublic />
    </div>
  );
};

export default SharedDashboard;
